<template>
  <div style="background-color: #f4f5fd">
    <b-row>
      <b-col cols="12">
        <!-- <h2>HR Workflow Settings</h2> -->
        <b-tabs>
          <b-tab
            title="Gifts"
            :lazy="$store.state.approvalsLazyLoad"
          >
            <WorkflowHrGiftsTable />
          </b-tab>
          <b-tab
            title="Governance"
            :lazy="$store.state.employeesLazyLoad"
          >
            <WorkflowHrNewEmployeeTable />
          </b-tab>
          <b-tab
            title="Complaints"
            :lazy="$store.state.complaintsLazyLoad"
          >
            <WorkflowHrComplaintsTable />
          </b-tab>
          <!-- <b-tab title="Contract Renew">
            <h1>Contract Renew</h1>
          </b-tab>
          <b-tab title="Policy Attestations">
            <h1>Policy Attestations</h1>
          </b-tab>
          <b-tab title="Employee Leave">
            <h1>Employee Leave</h1>
          </b-tab>
          <b-tab title="Leave Request">
            <h1>Leave Request</h1>
          </b-tab>
          <b-tab title="Expense Claim">
            <h1>Expense Claim</h1>
          </b-tab> -->
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import WorkflowHrGiftsTable from "../../../components/employeeComponents/employeeSettingsWorkFlowHrComponents/giftsTabComponents/workflowHrGiftsTable.vue";
import WorkflowHrNewEmployeeTable from "../../../components/employeeComponents/employeeSettingsWorkFlowHrComponents/employeeTabComponents/workflowHrNewEmployeeTable.vue";
import WorkflowHrComplaintsTable from "../../../components/employeeComponents/employeeSettingsWorkFlowHrComponents/complaintsTabComponents/workflowHrComplaintsTable.vue";
export default {
  name: "workFlows",
  components: {
    WorkflowHrGiftsTable,
    WorkflowHrNewEmployeeTable,
    WorkflowHrComplaintsTable,
  },
};
</script>
<style scoped>
@import "../../../assets/styles/theme1/tabs.css";
@import "../../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>
